import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef, OverlayConfig } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { SideAlertsService } from './side-alerts.service';
import { SideAlertAction } from 'models';
import { CommonModule } from '@angular/common';

const MOBILEVIEWWIDTH = 575;

@Component({
  selector: 'app-side-alert',
  templateUrl: './side-alert.component.html',
  styleUrl: './side-alert.component.css',
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class SideAlertComponent implements OnInit {

  @Input() isShowKeepAnswer: boolean = false;
  @Input() KeepAnswerofQuestion: string = undefined;
  @Input() isShowEnableGuide: boolean = false;
  @Input() isViewQuestionInfo: boolean = true;
  @Input() isViewClickProductInfo: boolean = false;
  @Input() isShowDeactivateGuide: boolean = false;
  @Input() isShowProductDetailInfo: boolean = false;
  @Output() onClick = new EventEmitter<SideAlertAction>();
  
  @ViewChild("SideAlertView") SideAlertView: TemplateRef<any>;
  overlayref: OverlayRef;


  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private sideAlerts: SideAlertsService
  ) { }

  ngOnInit(): void {
    // this.createOverlay();
  }

  ngAfterViewInit() {
    this.createOverlay();
  }

  createOverlay() {
    let position = this.overlay.position().global().right();
    position = window.screen.width < MOBILEVIEWWIDTH ? position.bottom() : position.centerVertically();
    const config = new OverlayConfig({positionStrategy: position, disposeOnNavigation: true});
    this.overlayref = this.overlay.create(config);
    this.overlayref.attach(new TemplatePortal(this.SideAlertView, this.viewContainerRef));
  }

  closeOverlay() {
    if (this.overlayref) {
      this.overlayref.detach();
      this.overlayref.dispose();
      this.overlayref=null;
    }
  }

  keepAnswerClicked() {
    this.onClick.emit('keepAnswer');
  }

  enableGuide() {
    this.onClick.emit('activateGuide');
  }

  deactivateGuide() {
    this.onClick.emit('deactivateGuide');
  }

}
